// @ts-ignore
import { isShopee } from '@/config/core';
import userStore from '@/stores/user/index';

// 获取 display_logic 的实验组
export const getLiveAgentDisplayLogic = () => {
  return (userStore.newABTestingConfigs as any)?.display_logic;
};

// 限制只有Shopee App才触发
export const isDisableDisplayWithNewFlow = () => {
  return isShopee() && (userStore.newABTestingConfigs as any)?.display_logic === 'disable_display_with_new_flow';
};


